import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export type BoxUniDriver = BaseUniDriver;
